import React, { useEffect, useState } from 'react';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';
import { FormDetailModel } from 'types/FormTypes';
import DatePicker from 'components/atomic/DatePicker';
import FormImage from './FormImage';

type FormDatePickerProps = {
  name: string;
  formRef: FormikProps<any> | null;
  formData: FormDetailModel;
  hasFieldValidation?: boolean;
  updateFormField: (name: string, value: any) => void;
};

const FormDatePicker: React.FC<FormDatePickerProps> = ({
  name,
  formRef,
  formData,
  updateFormField,
  hasFieldValidation,
}) => {
  const [date, setDate] = useState<Date>(new Date());
  const { t } = useTranslation('translation', {
    keyPrefix: 'drawers.formDrawer.datePicker',
  });

  // Track if we've already initialized to prevent double-setting
  const initializedRef = React.useRef(false);

  useEffect(() => {
    setDate(formRef?.values[name] === '' ? new Date() : formRef?.values[name]);
  }, []);

  useEffect(() => {
    async function updateDate() {
      await updateFormField(name, date);
    }
    updateDate();
  }, [date, updateFormField, name]);

  return (
    <div className='w-full h-full flex flex-col justify-start px-3 overflow-auto'>
      {formData.image && (
        <FormImage image={formData.image} alt='form-question-image' />
      )}
      <h5
        tabIndex={0}
        className={`text-left text-lg leading-formTitle font-semibold text-black ${
          !formData.subText ? 'mb-3' : 'mb-0'
        }`}
      >
        {formData.text}
      </h5>
      {formData.subText && (
        <p
          tabIndex={0}
          className='mt-1.5 mb-4 text-left text-xs font-semibold leading-formSubtitle text-muted'
        >
          {formData.subText}
        </p>
      )}
      <DatePicker
        selectedDate={date}
        label={t('placeholder')}
        errorMessage={t('errorMessage')}
        changeDate={(date: any) => setDate(date)}
      />
      {hasFieldValidation && formRef?.errors[name] && (
        <span className='text-warning text-[0.8rem]'>
          {formRef.errors[name] as string}
        </span>
      )}
    </div>
  );
};

export default FormDatePicker;
